import * as React from "react";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import styled, { css } from "styled-components";
import { isInputRunning, isInputInSetupMode } from "components/inputs/helpers/inputState";
import useInputStateMutations from "hooks/useInputsStateMutations";
import useFeature from "hooks/useFeature";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import { Button } from "components/bootstrap";
import { INPUT_SETUP_MODE_FEATURE_FLAG } from "components/inputs/InputSetupWizard";
const StateActionButton = styled(Button)(
  () => css`
    min-width: 95px;
  `
);
const InputStateControl = ({ input, openWizard, inputStates }) => {
  const { t } = useTranslation("inputs");
  const sendTelemetry = useSendTelemetry();
  const [isLoading, setIsLoading] = useState(false);
  const inputSetupFeatureFlagIsEnabled = useFeature(INPUT_SETUP_MODE_FEATURE_FLAG);
  const { startInput: startInputMutation, stopInput: stopInputMutation } = useInputStateMutations(input);
  const startInput = () => {
    setIsLoading(true);
    sendTelemetry(TELEMETRY_EVENT_TYPE.INPUTS.INPUT_START_CLICKED, {
      app_action_value: "start-input"
    });
    startInputMutation({ inputId: input.id }).finally(() => {
      setIsLoading(false);
    });
  };
  const stopInput = () => {
    setIsLoading(true);
    sendTelemetry(TELEMETRY_EVENT_TYPE.INPUTS.INPUT_STOP_CLICKED, {
      app_action_value: "stop-input"
    });
    stopInputMutation({ inputId: input.id }).finally(() => {
      setIsLoading(false);
    });
  };
  const setupInput = () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.INPUTS.INPUT_SETUP_CLICKED, {
      app_action_value: "setup-input"
    });
    openWizard();
  };
  if (inputSetupFeatureFlagIsEnabled && isInputInSetupMode(inputStates, input.id)) {
    return /* @__PURE__ */ React.createElement(StateActionButton, { bsStyle: "warning", bsSize: "xsmall", onClick: setupInput }, t("state_control.set_up"));
  }
  if (isInputRunning(inputStates, input.id)) {
    return /* @__PURE__ */ React.createElement(StateActionButton, { bsSize: "xsmall", onClick: stopInput, disabled: isLoading }, isLoading ? t("state_control.stopping") : t("state_control.stop"));
  }
  return /* @__PURE__ */ React.createElement(StateActionButton, { bsStyle: "primary", bsSize: "xsmall", onClick: startInput, disabled: isLoading }, isLoading ? t("state_control.starting") : t("state_control.start"));
};
export default InputStateControl;
